import { AdminLayout, useTranslation } from "@opendash/core";
import { useParams } from "@opendash/router";
import { AdminToolbar } from "@opendash/ui";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import {
  KanbanContextProvider,
  KanbanManager,
  useProject,
} from "../../features/tickets";
import { ProjectDuedateIcon } from "../../features/tickets/projects/components/card-items/ProjectDuedateIcon";

type Props = {};

export const ProjectPage = observer((props: Props) => {
  const t = useTranslation();
  const { id } = useParams();
  const { project } = useProject(id);
  const kanbanManager = useMemo(
    () =>
      new KanbanManager({
        defaultView: "state",
        viewtype: "list",
        lskey: "project",
        defaultTicketManagerConfig: {
          filters: {
            project: {
              attribute: "project",
              value: id,
            },
          },
        },
      }),
    []
  );

  return (
    <AdminLayout>
      <AdminToolbar
        title={t("maintenance:menu.tickets.project_label", {
          project: project?.get("name") ?? "",
        })}
        description={project?.get("description") ?? ""}
        actions={<>{project && <ProjectDuedateIcon project={project} />}</>}
      />

      <KanbanContextProvider value={kanbanManager}>
        {kanbanManager.getViewComponent()}
      </KanbanContextProvider>
    </AdminLayout>
  );
});
